import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/layoff-preparedness-calculator/LayoffPrepContent.tsx");
